export default "__VITE_ASSET__Bc7Lw9Dx__"